module.exports = __webpack_public_path__ + "static/img/table-text.6e61d92c.png";